import React, { Component } from "react";
import { Layout, Icon, Col, Tooltip } from "antd";
import { Switch, Route } from "react-router-dom";
import PrivateRoute from "../components/PrivateRoute";
import { Link } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import UsuarioDrawer from "../components/UsuarioDrawer";
import "./MainLayout.css";
import { getUsuarioToken, removeToken } from "../utils/LoginManager";
import SideMenu from "./SideMenu";
import './SideMenu.css';
import ContentRoutes from './ContentRoutes';
import Colors from '../utils/Colors';
import ParametrosDrawer from "../components/ParametrosDrawer";

const { Header } = Layout;

export default class MainLayout extends Component {
  state = {
    tipoUsuario: '',
  };

  sair = async () => {
    removeToken();
    this.props.history.push("/login");
  };

  renderConteudo = () => {
    const usuario = getUsuarioToken();

    return (
      <Layout className="mainLayout">
        <SideMenu />

        <Layout>
          <Header className="mainLayoutHeader" style={{ background: Colors.primary }}>
            <Col xs={20} style={{ textAlign: 'center' }}>
              <Icon type="home" className="iconeLayout" style={{ color: Colors.dividerLight }} />
              <span style={{ color: Colors.dividerLight, fontSize: 18 }}> {usuario ? usuario.emp_nome : ''}</span>
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 2 }}>
              <UsuarioDrawer />
            </Col>

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <Tooltip title="Sobre o App">
                <Link to="/sobre">
                  <Icon type="info-circle-o" />
                </Link>
              </Tooltip>
            </Col>

            {usuario && !usuario.usu_tipo ? (
              <Col xs={1} style={{ textAlign: 'right', marginTop: 4 }}>
                <ParametrosDrawer />
              </Col>
            ) : null}

            <Col xs={1} style={{ textAlign: 'right', marginTop: 4, paddingLeft: 20 }}>
              <a href="" onClick={this.sair}>
                <Tooltip title="Sair" placement="bottomLeft">
                  <Icon type="logout" />
                </Tooltip>
              </a>
            </Col>

          </Header>

          <ContentRoutes />
        </Layout>

      </Layout>
    );
  };

  render() {
    return (
      <Switch>
        <Route path="/login" component={LoginPage} />
        <PrivateRoute render={this.renderConteudo} />
        <div>Página Inicial</div>
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/MainLayout.js